
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bounty-creative",
      function () {
        return require("private-next-pages/bounty-creative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bounty-creative"])
      });
    }
  